import * as Mod1 from "./discourse/adapters/circle";
import * as Mod2 from "./discourse/circles-route-map";
import * as Mod3 from "./discourse/components/circles/add-circles-category-body-class";
import * as Mod4 from "./discourse/components/circles/background";
import * as Mod5 from "./discourse/components/circles/card/actions";
import * as Mod6 from "./discourse/components/circles/card/badges";
import * as Mod7 from "./discourse/components/circles/card/index";
import * as Mod8 from "./discourse/components/circles/card/stats";
import * as Mod9 from "./discourse/components/circles/delete-button";
import * as Mod10 from "./discourse/components/circles/form-fields/base";
import * as Mod11 from "./discourse/components/circles/form-fields/checkbox";
import * as Mod12 from "./discourse/components/circles/form-fields/combo-box";
import * as Mod13 from "./discourse/components/circles/form-fields/conditional-char-counter";
import * as Mod14 from "./discourse/components/circles/form-fields/custom";
import * as Mod15 from "./discourse/components/circles/form-fields/custom/base";
import * as Mod16 from "./discourse/components/circles/form-fields/custom/confirm";
import * as Mod17 from "./discourse/components/circles/form-fields/custom/dropdown";
import * as Mod18 from "./discourse/components/circles/form-fields/custom/multi-select";
import * as Mod19 from "./discourse/components/circles/form-fields/custom/text";
import * as Mod20 from "./discourse/components/circles/form-fields/dropdown";
import * as Mod21 from "./discourse/components/circles/form-fields/editor";
import * as Mod22 from "./discourse/components/circles/form-fields/image-uploader";
import * as Mod23 from "./discourse/components/circles/form-fields/multi-select";
import * as Mod24 from "./discourse/components/circles/form-fields/text";
import * as Mod25 from "./discourse/components/circles/form-fields/validation-tip";
import * as Mod26 from "./discourse/components/circles/form-fields/wire-frame";
import * as Mod27 from "./discourse/components/circles/form-profile-fields";
import * as Mod28 from "./discourse/components/circles/logo";
import * as Mod29 from "./discourse/components/circles/manage-ownership-button";
import * as Mod30 from "./discourse/components/circles/member-actions";
import * as Mod31 from "./discourse/components/circles/members-dropdown-actions";
import * as Mod32 from "./discourse/components/circles/members-dropdown-bulk-actions";
import * as Mod33 from "./discourse/components/circles/membership-button";
import * as Mod34 from "./discourse/components/circles/membership-post-request";
import * as Mod35 from "./discourse/components/circles/navigation-combo-box";
import * as Mod36 from "./discourse/components/circles/notifications-button";
import * as Mod37 from "./discourse/components/circles/privacy-status";
import * as Mod38 from "./discourse/components/circles/search-fields/base";
import * as Mod39 from "./discourse/components/circles/search-fields/combobox";
import * as Mod40 from "./discourse/components/circles/search-fields/confirm";
import * as Mod41 from "./discourse/components/circles/search-fields/custom";
import * as Mod42 from "./discourse/components/circles/search-fields/dropdown";
import * as Mod43 from "./discourse/components/circles/search-fields/multi-select";
import * as Mod44 from "./discourse/components/circles/search-fields/text";
import * as Mod45 from "./discourse/components/circles/search-fields/wire-frame";
import * as Mod46 from "./discourse/components/circles/user-dropdown";
import * as Mod47 from "./discourse/components/circles/user-nav-circles-item";
import * as Mod48 from "./discourse/components/circles/user-notification-preferences";
import * as Mod49 from "./discourse/components/circles/view/navigation-tabs";
import * as Mod50 from "./discourse/components/modal/add-members";
import * as Mod51 from "./discourse/components/modal/manage-advanced-ownership";
import * as Mod52 from "./discourse/components/modal/membership-reason";
import * as Mod53 from "./discourse/controllers/circle";
import * as Mod54 from "./discourse/controllers/circle/about";
import * as Mod55 from "./discourse/controllers/circle/activity/topics";
import * as Mod56 from "./discourse/controllers/circle/manage/profile";
import * as Mod57 from "./discourse/controllers/circle/members";
import * as Mod58 from "./discourse/controllers/circle/requests";
import * as Mod59 from "./discourse/controllers/circle/staff";
import * as Mod60 from "./discourse/controllers/circles";
import * as Mod61 from "./discourse/controllers/circles/index";
import * as Mod62 from "./discourse/controllers/circles/new";
import * as Mod63 from "./discourse/controllers/user/circles";
import * as Mod64 from "./discourse/initializers/discourse-circles";
import * as Mod65 from "./discourse/lib/html-helpers";
import * as Mod66 from "./discourse/lib/model-attribute";
import * as Mod67 from "./discourse/models/attributes";
import * as Mod68 from "./discourse/models/circle";
import * as Mod69 from "./discourse/routes/circle";
import * as Mod70 from "./discourse/routes/circle/about";
import * as Mod71 from "./discourse/routes/circle/activity";
import * as Mod72 from "./discourse/routes/circle/activity/index";
import * as Mod73 from "./discourse/routes/circle/activity/posts";
import * as Mod74 from "./discourse/routes/circle/activity/topics";
import * as Mod75 from "./discourse/routes/circle/index";
import * as Mod76 from "./discourse/routes/circle/manage";
import * as Mod77 from "./discourse/routes/circle/manage/advanced";
import * as Mod78 from "./discourse/routes/circle/manage/index";
import * as Mod79 from "./discourse/routes/circle/manage/profile";
import * as Mod80 from "./discourse/routes/circle/members";
import * as Mod81 from "./discourse/routes/circle/requests";
import * as Mod82 from "./discourse/routes/circle/staff";
import * as Mod83 from "./discourse/routes/circles";
import * as Mod84 from "./discourse/routes/circles/index";
import * as Mod85 from "./discourse/routes/circles/new";
import * as Mod86 from "./discourse/routes/user/circles";
import * as Mod87 from "./discourse/routes/user/circles/index";
import * as Mod88 from "./discourse/routes/user/circles/type";
import * as Mod89 from "./discourse/services/circles";
import * as Mod90 from "./discourse/services/current-circle";
import * as Mod91 from "./discourse/templates/circle";
import * as Mod92 from "./discourse/templates/circle/about";
import * as Mod93 from "./discourse/templates/circle/activity";
import * as Mod94 from "./discourse/templates/circle/activity/topics";
import * as Mod95 from "./discourse/templates/circle/manage";
import * as Mod96 from "./discourse/templates/circle/manage/advanced";
import * as Mod97 from "./discourse/templates/circle/manage/profile";
import * as Mod98 from "./discourse/templates/circle/members";
import * as Mod99 from "./discourse/templates/circle/requests";
import * as Mod100 from "./discourse/templates/circles/index";
import * as Mod101 from "./discourse/templates/circles/new";
import * as Mod102 from "./discourse/templates/user/circles";
import * as Mod103 from "./discourse/user-circles-route-map";
const compatModules = {
  "discourse/adapters/circle": Mod1,
  "discourse/circles-route-map": Mod2,
  "discourse/components/circles/add-circles-category-body-class": Mod3,
  "discourse/components/circles/background": Mod4,
  "discourse/components/circles/card/actions": Mod5,
  "discourse/components/circles/card/badges": Mod6,
  "discourse/components/circles/card/index": Mod7,
  "discourse/components/circles/card/stats": Mod8,
  "discourse/components/circles/delete-button": Mod9,
  "discourse/components/circles/form-fields/base": Mod10,
  "discourse/components/circles/form-fields/checkbox": Mod11,
  "discourse/components/circles/form-fields/combo-box": Mod12,
  "discourse/components/circles/form-fields/conditional-char-counter": Mod13,
  "discourse/components/circles/form-fields/custom": Mod14,
  "discourse/components/circles/form-fields/custom/base": Mod15,
  "discourse/components/circles/form-fields/custom/confirm": Mod16,
  "discourse/components/circles/form-fields/custom/dropdown": Mod17,
  "discourse/components/circles/form-fields/custom/multi-select": Mod18,
  "discourse/components/circles/form-fields/custom/text": Mod19,
  "discourse/components/circles/form-fields/dropdown": Mod20,
  "discourse/components/circles/form-fields/editor": Mod21,
  "discourse/components/circles/form-fields/image-uploader": Mod22,
  "discourse/components/circles/form-fields/multi-select": Mod23,
  "discourse/components/circles/form-fields/text": Mod24,
  "discourse/components/circles/form-fields/validation-tip": Mod25,
  "discourse/components/circles/form-fields/wire-frame": Mod26,
  "discourse/components/circles/form-profile-fields": Mod27,
  "discourse/components/circles/logo": Mod28,
  "discourse/components/circles/manage-ownership-button": Mod29,
  "discourse/components/circles/member-actions": Mod30,
  "discourse/components/circles/members-dropdown-actions": Mod31,
  "discourse/components/circles/members-dropdown-bulk-actions": Mod32,
  "discourse/components/circles/membership-button": Mod33,
  "discourse/components/circles/membership-post-request": Mod34,
  "discourse/components/circles/navigation-combo-box": Mod35,
  "discourse/components/circles/notifications-button": Mod36,
  "discourse/components/circles/privacy-status": Mod37,
  "discourse/components/circles/search-fields/base": Mod38,
  "discourse/components/circles/search-fields/combobox": Mod39,
  "discourse/components/circles/search-fields/confirm": Mod40,
  "discourse/components/circles/search-fields/custom": Mod41,
  "discourse/components/circles/search-fields/dropdown": Mod42,
  "discourse/components/circles/search-fields/multi-select": Mod43,
  "discourse/components/circles/search-fields/text": Mod44,
  "discourse/components/circles/search-fields/wire-frame": Mod45,
  "discourse/components/circles/user-dropdown": Mod46,
  "discourse/components/circles/user-nav-circles-item": Mod47,
  "discourse/components/circles/user-notification-preferences": Mod48,
  "discourse/components/circles/view/navigation-tabs": Mod49,
  "discourse/components/modal/add-members": Mod50,
  "discourse/components/modal/manage-advanced-ownership": Mod51,
  "discourse/components/modal/membership-reason": Mod52,
  "discourse/controllers/circle": Mod53,
  "discourse/controllers/circle/about": Mod54,
  "discourse/controllers/circle/activity/topics": Mod55,
  "discourse/controllers/circle/manage/profile": Mod56,
  "discourse/controllers/circle/members": Mod57,
  "discourse/controllers/circle/requests": Mod58,
  "discourse/controllers/circle/staff": Mod59,
  "discourse/controllers/circles": Mod60,
  "discourse/controllers/circles/index": Mod61,
  "discourse/controllers/circles/new": Mod62,
  "discourse/controllers/user/circles": Mod63,
  "discourse/initializers/discourse-circles": Mod64,
  "discourse/lib/html-helpers": Mod65,
  "discourse/lib/model-attribute": Mod66,
  "discourse/models/attributes": Mod67,
  "discourse/models/circle": Mod68,
  "discourse/routes/circle": Mod69,
  "discourse/routes/circle/about": Mod70,
  "discourse/routes/circle/activity": Mod71,
  "discourse/routes/circle/activity/index": Mod72,
  "discourse/routes/circle/activity/posts": Mod73,
  "discourse/routes/circle/activity/topics": Mod74,
  "discourse/routes/circle/index": Mod75,
  "discourse/routes/circle/manage": Mod76,
  "discourse/routes/circle/manage/advanced": Mod77,
  "discourse/routes/circle/manage/index": Mod78,
  "discourse/routes/circle/manage/profile": Mod79,
  "discourse/routes/circle/members": Mod80,
  "discourse/routes/circle/requests": Mod81,
  "discourse/routes/circle/staff": Mod82,
  "discourse/routes/circles": Mod83,
  "discourse/routes/circles/index": Mod84,
  "discourse/routes/circles/new": Mod85,
  "discourse/routes/user/circles": Mod86,
  "discourse/routes/user/circles/index": Mod87,
  "discourse/routes/user/circles/type": Mod88,
  "discourse/services/circles": Mod89,
  "discourse/services/current-circle": Mod90,
  "discourse/templates/circle": Mod91,
  "discourse/templates/circle/about": Mod92,
  "discourse/templates/circle/activity": Mod93,
  "discourse/templates/circle/activity/topics": Mod94,
  "discourse/templates/circle/manage": Mod95,
  "discourse/templates/circle/manage/advanced": Mod96,
  "discourse/templates/circle/manage/profile": Mod97,
  "discourse/templates/circle/members": Mod98,
  "discourse/templates/circle/requests": Mod99,
  "discourse/templates/circles/index": Mod100,
  "discourse/templates/circles/new": Mod101,
  "discourse/templates/user/circles": Mod102,
  "discourse/user-circles-route-map": Mod103,
};
export { compatModules };
export default compatModules;
